import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'
import { StaticImage } from 'gatsby-plugin-image'

export default function ContentCards5({ data }) {
    const { contentCards5ButtonLink, contentCards5Title, contentCards5Text, contentCards5ButtonText, contentCards5Cards, contentCards5ShowTopIcon, contentCards5ButtonExternalLinks } = data
    return (
        <div className='offer-wrap panel-space-70'>
            <div className='container sm-container-1'>
                <div className='row mb-4'>
                    <div className={`col-md-12 ${contentCards5ShowTopIcon && 'text-center'}`}>
                        {contentCards5ShowTopIcon && (
                            <figure className='abt-origins-icon'>
                                <StaticImage
                                    src='../../../images/origins-icon.png'
                                    alt='image'
                                />
                            </figure>
                        )}
                        <h2 className='heading-level-2 blue-color text-center'>
                            {contentCards5Title && parser(contentCards5Title)}
                        </h2>
                        {contentCards5Text && (
                            <p>
                                <strong>{parser(contentCards5Text)}</strong>
                            </p>
                        )}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        {contentCards5Cards.map((block, i) => (
                            <div className='offer-blue-row' key={i}>
                                <div className='offer-image-col'>
                                    <GatsbyImage
                                        image={getImage(block.contentCards5CardIcon?.localFile)}
                                        alt='image'
                                    />
                                </div>
                                <div className='offer-content-col'>
                                    <div className='heading-level-4-b blue-color'>
                                        {block.contentCards5CardTitle && parser(block.contentCards5CardTitle)}
                                    </div>
                                    <p>{block.contentCards5CardText && parser(block.contentCards5CardText)}</p>
                                </div>
                            </div>
                        ))}
                        {contentCards5ButtonLink && (
                            <div className='col-md-12 text-center mt-5'>
                                {contentCards5ButtonExternalLinks ? (
                                    <a href={contentCards5ButtonExternalLinks} className="btn blue-btn">
                                        {contentCards5ButtonText}
                                    </a>
                                ) : contentCards5ButtonLink ? (
                                    <a
                                        href={`mailto:${contentCards5ButtonLink}`}
                                        className='btn blue-btn'
                                    >
                                        {contentCards5ButtonText}
                                    </a>
                                ) : null}


                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
